export default {"src":"/nachrichten/_next/static/media/ThemeDarkIcon.3014cc82.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};